// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/sweetalert/dist/sweetalert.css
// module id = 1337
// module chunks = 0